import SkeletonValuePlaceholder from 'src/components/SkeletonValuePlaceholder/SkeletonValuePlaceholder';
import Tooltip from 'src/components/primitives/Tooltip/Tooltip';
import MarketIcon from 'src/components/Utils/MarketIcon';
import { cm } from 'src/utils/classNames';

export const PerformanceBreakdownStat = (props: {
	label: string;
	value: string;
	marketSymbol?: string; // displays the market icon if provided
	loading?: boolean;
	tooltip?: string;
	customIcon?: React.ReactNode;
	className?: string;
}) => {
	const innerContent = <span className="typo-b4">{props.label}</span>;
	return (
		<div
			className={cm(
				'flex w-full flex-row items-start justify-between gap-y-xs sm:flex-col',
				props.className
			)}
		>
			<div className="flex items-center gap-1 text-text-secondary">
				{props.tooltip ? (
					<Tooltip content={props.tooltip}>{innerContent}</Tooltip>
				) : (
					innerContent
				)}
			</div>
			{props.loading ? (
				<SkeletonValuePlaceholder className="h-4 w-16" loading />
			) : (
				<div className="flex items-center gap-x-xs">
					{props.marketSymbol && (
						<MarketIcon marketSymbol={props.marketSymbol} className="h-4 w-4" />
					)}
					{props.customIcon && props.customIcon}
					<span className="typo-t3">{props.value}</span>
				</div>
			)}
		</div>
	);
};
